import React from 'react';
import { Input, Select, Button, TableContainer, FieldSet, FormGroup, Validator as V } from 'hrone-react';
import { observer } from 'mobx-react';
import './index.less';
import mainStore from '../main.store';
import store from './index.store';

@observer
export default class Organization extends React.PureComponent {
    componentDidMount() {
        store.clearValidation();
    }

    componentWillUnmount() {
        store.clearStore();
    }
    render() {
        return (
            <div className='forget-form'>
                <V.Form className='forget-form-wrapper' store={store}>
                    <div className='forget-form-label'>
                        <FieldSet className='forget-form-fieldSet' size='large' cols={1}>
                            <FormGroup className='phone-group' title='手机号' layout='vertical'>
                                <div>
                                    <V.Select
                                        className='phone-select'
                                        field='resetPasswordForm.areaCode'
                                        options={mainStore.areaCodeOptions}
                                        autoSelect={true}
                                        allowEmpty={false}
                                        tetherable={true}
                                    />
                                    <V.Input field='resetPasswordForm.phoneNum' className='phone-input' />
                                </div>
                            </FormGroup>
                            <FormGroup className='code-group' title='验证码' layout='vertical'>
                                <V.Input className='code-input' field='resetPasswordForm.verificationCode' />
                                <Button
                                    className={store.isSendCode ? 'forget-code-countdown' : 'forget-code'}
                                    type='primary'
                                    disabled={store.isSendCode}
                                    onClick={store.toSendCode}>
                                    {store.isSendCode ? store.countdown + 's' : store.sendCodeTip}
                                </Button>
                            </FormGroup>
                            <FormGroup title='新密码'>
                                <V.Password field='resetPasswordForm.newPassword' />
                            </FormGroup>
                        </FieldSet>
                    </div>
                    <div className='forget-form-button' onClick={store.submit}>
                        重置密码
                    </div>
                    <div className='back' onClick={mainStore.toResetPassword}>
                        返回
                    </div>
                </V.Form>
                <div className="recordNo">
                    <span>Copyright 2010-2019GaiaWorks Corporation，All Rights Reserved 盖雅工场版权所有 | </span><a href='http://www.miitbeian.gov.cn'>苏ICP备12047504号-3</a>
                </div>
            </div>
        );
    }
}
